import { render, staticRenderFns } from "./SearchQueryList.vue?vue&type=template&id=f8ce20b4&"
import script from "./SearchQueryList.vue?vue&type=script&lang=js&"
export * from "./SearchQueryList.vue?vue&type=script&lang=js&"
import style0 from "./SearchQueryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports